import React from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";  
import "../styles/BackButton.scss";

const BackButton: React.FC = () => {
  const navigate = useNavigate();
  const Icon = IoArrowBack as React.ElementType; 

  return (
    <div className="back-button" onClick={() => navigate(-1)}>
      <Icon className="back-icon" />  
    </div>
  );
};

export default BackButton;
